export default __webpack_public_path__ + "static/media/ri_checkbox-circle-fill.2756dc7b.svg";